module.exports = __webpack_public_path__ + "img/thumb_active.b36474dc.png";